import { useCallback, useEffect } from 'react';
import { PrimitiveAtom, useAtomValue, useSetAtom } from 'jotai';
import queryString from 'query-string';
import { updateUrl } from '@/utils';
import { shouldDisableCleanDefect } from '@/utils/defects';

type ToggleableDefectLegend = { id: string | number; name: string; isEnabled: boolean };

export type DefectsDeeplinkState = {
  shouldUpdateUrl: boolean;
  selectedStructureDefectsLegendsAtom: PrimitiveAtom<Array<ToggleableDefectLegend> | undefined>;
};

export const useDefectsDeeplink = (state: DefectsDeeplinkState) => {
  const { shouldUpdateUrl, selectedStructureDefectsLegendsAtom } = state;

  const selectedStructureDefectsLegends = useAtomValue(selectedStructureDefectsLegendsAtom);
  const setSelectedStructureDefectsLegends = useSetAtom(selectedStructureDefectsLegendsAtom);

  useEffect(() => {
    if (shouldUpdateUrl) {
      updateUrl(
        'defects',
        selectedStructureDefectsLegends
          ?.filter((defect) => defect.isEnabled === true)
          .map((defect) => JSON.stringify(defect.id))
      );
    }
  }, [shouldUpdateUrl, selectedStructureDefectsLegends]);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (parsed.defects) {
        setSelectedStructureDefectsLegends((currentDefects) => {
          return currentDefects?.map((defect) => {
            if (parsed.defects?.includes(JSON.stringify(defect.id))) {
              return { ...defect, isEnabled: shouldDisableCleanDefect(defect.name) };
            }
            return defect;
          });
        });
      }
    },
    [setSelectedStructureDefectsLegends]
  );

  return { applyFromParsed };
};
